export default {
  getUTCFullDate: (date = new Date()) => new Date(date).toUTCString().slice(0, -12),
  getUTCDay: (date = new Date()) => new Date(date).toUTCString().split(',')[0],
  getUTCDate: (date = new Date()) => new Date(date).toUTCString().split(' ')[1],
  getUTCMonth: (date = new Date()) => new Date(date).toUTCString().split(' ')[2],
  getUTCYear: (date = new Date()) => new Date(date).toUTCString().split(' ')[3],
  getUTCTime: (date = new Date()) => new Date(date).toUTCString().split(' ')[4],
  getUTCShortTime: (date = new Date()) => new Date(date).toUTCString().split(' ')[4].slice(0, 5),

};
